import script from "./PageSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./PageSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./PageSkeleton.vue?vue&type=style&index=0&id=4069fddc&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4069fddc"]])

export default __exports__